import React from 'react';

interface Props {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  crop?: Record<string, number> | string;
  hotspot?: Record<string, number> | string;
  className?: string;
  onError?: () => void;
  title?: string;
  sizes?: string;
}
export default function EditorialImage({
  src,
  alt,
  width,
  height,
  crop,
  hotspot,
  className,
  onError,
  title,
  sizes,
}: Props) {
  const geometry = typeof crop === 'string' ? JSON.parse(crop) : crop;
  const focus = typeof hotspot === 'string' ? JSON.parse(hotspot) : hotspot;
  const left = geometry?.left || 0,
    right = geometry?.right || 0,
    top = geometry?.top || 0,
    bottom = geometry?.bottom || 0;
  const retainedWidth = 1 - left - right,
    retainedHeight = 1 - top - bottom;
  if (retainedWidth <= 0 || retainedHeight <= 0) throw new Error('Invalid image crop');
  const position = focus ? `${100 * (focus.x ?? 0.5)}% ${100 * (focus.y ?? 0.5)}%` : undefined;
  if (geometry && width && height)
    return (
      <span
        className={className}
        style={{
          display: 'block',
          position: 'relative',
          overflow: 'hidden',
          aspectRatio: `${width * retainedWidth} / ${height * retainedHeight}`,
        }}
      >
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={onError}
          title={title}
          sizes={sizes}
          style={{
            position: 'absolute',
            maxWidth: 'none',
            width: `${100 / retainedWidth}%`,
            height: `${100 / retainedHeight}%`,
            left: `${(-100 * left) / retainedWidth}%`,
            top: `${(-100 * top) / retainedHeight}%`,
            objectPosition: position,
          }}
        />
      </span>
    );
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
      onError={onError}
      title={title}
      sizes={sizes}
      className={className}
      style={{ objectPosition: position }}
    />
  );
}
